module.exports = __webpack_public_path__ + "static/media/ic_upload.45da5e66.svg";